import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import Iconify from "../components/Iconify";
// context
import { ScrollContext } from "../context/ScrollContext";

// ----------------------------------------------------------------------

export default function Header({ darkModeEnabled, toggleMode }) {
  const { isScroll, jumpToTop } = useContext(ScrollContext);
  const [mobile, setMobile] = useState(false);
  return (
    <header className="container mx-auto flex justify-center">
      {/* <nav
        className={`fixed top-0 right-0 z-[1000] flex h-16 w-full items-center justify-between px-4 md:h-16 md:px-[4%] backdrop-blur-xl backdrop-filter}`}
      > */}
      <nav
        className={`fixed top-0 md:top-3 z-[1000] flex h-16 w-full lg:w-[1000px] border-[1px] border-none md:border-solid md:border-[#6bcfcc] rounded-none md:rounded-[999px] items-center justify-between px-4 md:h-16 md:px-[4%] backdrop-blur-xl backdrop-filter`}
      >
        <h3
          className="text-md cursor-pointer font-lato font-semibold tracking-widest md:text-2xl"
          onClick={jumpToTop}
        >
          <a href="#about" className="hidden text-sm xs:text-lg md:block sm:font-bold">
            H.K
          </a>
        </h3>

        <ul className="flex items-center gap-2 md:gap-4 font-sans font-semibold">
          <li className="hover:text-[#43cbc0] hover:scale-105">
            <a
              href="#experience"
              className="hidden text-sm xs:text-lg md:block"
            >
              Experience
            </a>
          </li>
          <li className="hover:text-[#43cbc0] hover:scale-105">
            <a href="#education" className="hidden text-sm xs:text-lg md:block">
              Education
            </a>
          </li>
          <li className="hover:text-[#43cbc0] hover:scale-105">
            <a href="#skills" className="hidden text-sm xs:text-lg md:block">
              Skills
            </a>
          </li>
          <li className="hover:text-[#43cbc0] hover:scale-105">
            <a href="#projects" className="hidden text-sm xs:text-lg md:block">
              Projects
            </a>
          </li>
          {/* <li>
            <a
              href="#certification"
              className="hidden text-sm xs:text-lg md:block"
            >
              Certification
            </a>
          </li> */}
          <li className="hover:text-[#43cbc0] hover:scale-105">
            <a
              href="#testimonials"
              className="hidden text-sm xs:text-lg md:block"
            >
              Testimonials
            </a>
          </li>
          <li className="hover:text-[#43cbc0] hover:scale-105">
            <a href="#contact" className="hidden text-sm xs:text-lg md:block">
              Contact
            </a>
          </li>
          {/* <li>
            <button
              className="rounded-lg p-2.5 text-sm text-gray-500 outline-none hover:bg-gray-100 focus:outline-none  dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-700"
              onClick={toggleMode}
            >
              {darkModeEnabled ? (
                <svg
                  className="h-5 w-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                    fillRule="evenodd"
                    clipRule="evenodd"
                  />
                </svg>
              ) : (
                <svg
                  className="h-5 w-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
                </svg>
              )}
            </button>
          </li> */}
          <li>
            <a
              className="block text-sm xs:text-base md:hidden"
              onClick={() => {
                setMobile(!mobile);
              }}
            >
              <Iconify classes="text-xl" icon="pixelarticons:menu" />
            </a>
          </li>
        </ul>
      </nav>
      {mobile && (
        <ul className="fixed top-0 left-0 z-[999] flex h-[100vh] w-[100vw] flex-col gap-5 bg-[#fff1] pt-20 pl-6 text-lg backdrop-blur-xl backdrop-filter dark:bg-[#0002]">
          <li>
            <a
              href="#about"
              onClick={() => {
                setMobile(false);
              }}
            >
              About
            </a>
          </li>
          <li>
            <a
              href="#experience"
              onClick={() => {
                setMobile(false);
              }}
            >
              Experience
            </a>
          </li>
          <li>
            <a
              href="#education"
              onClick={() => {
                setMobile(false);
              }}
            >
              Education
            </a>
          </li>
          <li>
            <a
              href="#skills"
              onClick={() => {
                setMobile(false);
              }}
            >
              Skills
            </a>
          </li>
          <li>
            <a
              href="#projects"
              onClick={() => {
                setMobile(false);
              }}
            >
              Projects
            </a>
          </li>
          {/* <li>
            <a
              href="#certification"
              onClick={() => {
                setMobile(false);
              }}
            >
              Certification
            </a>
          </li> */}
          <li>
            <a
              href="#testimonials"
              onClick={() => {
                setMobile(false);
              }}
            >
              Testimonials
            </a>
          </li>
          <li>
            <a
              href="#contact"
              onClick={() => {
                setMobile(false);
              }}
            >
              Contact
            </a>
          </li>
        </ul>
      )}
    </header>
  );
}

// ----------------------------------------------------------------------

Header.propTypes = {
  darkModeEnabled: PropTypes.bool,
  toggleMode: PropTypes.func,
};
